
import React from "react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { MetalTabs, GoldForm, SilverForm } from "./";
import { ValuationFormProps } from "./types";

interface ValuationFormContainerProps extends ValuationFormProps {
  goldPrice: number;
  silverPrice: number;
  error: string | null;
  onRefreshPrices: () => void;
}

export function ValuationForm({
  selectedMetal,
  goldPurity,
  silverPurity,
  weight,
  unit,
  onMetalChange,
  onPurityChange,
  onWeightChange,
  onUnitChange,
  goldPrice,
  silverPrice,
  error,
  onRefreshPrices
}: ValuationFormContainerProps) {
  return (
    <Tabs defaultValue={selectedMetal} onValueChange={onMetalChange}>
      <MetalTabs selectedMetal={selectedMetal} onMetalChange={onMetalChange} />
      
      <TabsContent value="ORO">
        <GoldForm 
          goldPurity={goldPurity}
          weight={weight}
          goldPrice={goldPrice}
          onPurityChange={onPurityChange}
          onWeightChange={onWeightChange}
          onRefreshPrices={onRefreshPrices}
          error={error}
        />
      </TabsContent>
      
      <TabsContent value="ARGENTO">
        <SilverForm
          silverPurity={silverPurity}
          weight={weight}
          unit={unit}
          silverPrice={silverPrice}
          onPurityChange={onPurityChange}
          onWeightChange={onWeightChange}
          onUnitChange={onUnitChange}
          onRefreshPrices={onRefreshPrices}
          error={error}
        />
      </TabsContent>
    </Tabs>
  );
}
